<script setup lang="ts">
import { MODAL_OPEN, MODAL_SIZE_GUIDE, useModalStore } from '~/store/modalStore';

const props = defineProps<{
  isSentToUsizy: boolean
  sizeGuide: never
  categoryPath: string
  canonicalProductId: number
  locale: string
}>()

const {
  isSentToUsizy,
  sizeGuide,
  categoryPath,
  canonicalProductId,
  locale
} = toRefs(props)

const usizy = ref([]);

watch(usizy, () => {
  window.uSizy.init();
})

const modalStore = useModalStore();
const modal = () => modalStore.displayModal(MODAL_SIZE_GUIDE, MODAL_OPEN);
</script>

<template>
  <div v-if="isSentToUsizy || sizeGuide">
    <ClientOnly>
      <div
           v-if="isSentToUsizy"
           ref="usizy"
           class="usizy-external mb-1"
           data-usizy-item
           :data-category-path="categoryPath"
           :data-unique-product-id="canonicalProductId"
           data-layout="link"
           data-width="100%"
           :data-text="$t('www.product.size-guide.usizy.text')"
           :data-language="locale"/>
      <div v-if="isSentToUsizy" style="height: 20px;"></div>
    </ClientOnly>
    <div v-if="!isSentToUsizy" style="text-align: right">
        <span
             class="size--headline weight--intermedium pointer product-page-sizeguide--custom mb-1"
              data-tclz-selector="size-guide"
              :data-tclz-label="categoryPath"
              data-tclz-category="product"
              @click="modal">
              {{ $t('www.product.sizeguide.0') }}
        </span>
    </div>
  </div>
</template>
